// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — clock.styled.classic.js, новая — clock.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './clock.styled.classic';
import * as cp from './clock.styled.cp';

export const ClockLabel = isCp ? cp.ClockLabel : classic.ClockLabel;
export const Content = isCp ? cp.Content : classic.Content;
export const Dial = isCp ? cp.Dial : classic.Dial;
export const Hand = isCp ? cp.Hand : classic.Hand;
